/* istanbul ignore file */
import React from 'react';
import { useLocation } from 'react-router-dom';
import { Tooltip } from 'framework/ui/mui-builder';
import LinkIcon from '@mui/icons-material/LinkOutlined';
import { copyToClipboard } from 'framework/ui/clipboard';
import { Box } from '@mui/material';

type PersonTimelineRecordAnchorProps = {
  timelineId: string | number;
  basePathname?: string;
};

const PersonTimelineRecordAnchor = ({ timelineId, basePathname = '' }: PersonTimelineRecordAnchorProps) => {
  const { pathname } = useLocation();
  const pathnameWithoutEntryId = basePathname || pathname.replace(/\/\d+$/, '');
  const link = `${pathnameWithoutEntryId}/${timelineId}`;

  const handleAnchorClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    copyToClipboard(e.currentTarget.href);
  };

  return (
    <Tooltip id={`anchor-entry${timelineId}`} arrow placement="bottom-end" title="Copy link">
      <Box
        component="a"
        href={link}
        onClick={handleAnchorClick}
        id={`anchor-entry${timelineId}`}
        className="copy-anchor"
        ref={{ current: null }}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          cursor: 'pointer',
          '& svg': {
            width: '18px',
            height: '18px',
            color: 'text.secondary',
            verticalAlign: 'middle',
          },
          '&:hover svg': { color: 'text.primary' },
        }}
      >
        <LinkIcon />
      </Box>
    </Tooltip>
  );
};

export default PersonTimelineRecordAnchor;
